import { createStripeElement } from './createStripeElement';

export const CardElement = createStripeElement('card');
export const CardCVCElement = createStripeElement('cardCvc');
